import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const elseElement: SugarElementInfo = { name: "else", availableChildren: { type: AvailableChildrenType.Any } };
